import React, { Component } from 'react'
import { Auth, Hub } from 'aws-amplify'

import Router from './Router'
import UserContext from './UserContext'

/**
 * Appコンポーネント
 * - https://aws-amplify.github.io/amplify-js/api/classes/authenticator.html
 */
class App extends Component {
  // コンストラクタ？
  state = {
    // ユーザ
    currentUser: null,
    // ユーザの読み込み完了
    isLoaded: false
  }
  // コンポーネントがマウントされた（ツリーに挿入された）直後に呼び出されます
  componentDidMount() {
    this.updateCurrentUser()
    this.unsubscribeAuth = Hub.listen('auth', () => {
      this.updateCurrentUser();
    });
  }
  componentWillUnmount() {
    // 解除は返ってきた関数を呼ぶ（存在チェックで防御的に）
    if (typeof this.unsubscribeAuth === 'function') {
      this.unsubscribeAuth();
    }
  }

  /**
   * 使用ユーザの更新（async/await構文）
   * 
   * @param {*} user 
   * @returns 
   */
  updateCurrentUser = async (user) => {
    // 引数ユーザがあるならステータスにセットして終わり
    if (user) {
      this.setState({ currentUser: user, isLoaded: true })
      return
    }

    // ユーザ認証を行う
    try {
      // aws-amplifyの認証。現在の認証済みユーザを取得する
      const user = await Auth.currentAuthenticatedUser()
      // ステータス更新。ユーザと読み込み完了
      this.setState({ currentUser: user, isLoaded: true })
    } catch (err) {
      this.setState({ currentUser: null, isLoaded: true })
    }
  }
  render() {
    return (
      // valueの中身が変更されると再Renderする
      <UserContext.Provider value={{
        // ログインユーザ
        user: this.state.currentUser,
        // 互換のため
        currentUser: this.state.currentUser,
        // 更新完了
        isLoaded: this.state.isLoaded,
        // ユーザの更新
        updateCurrentUser: this.updateCurrentUser
      }}>
        <div className="App">
          <Router />
        </div>
      </UserContext.Provider>
    );
  }
}

// Appをexport
export default App
